import { Card, Dialog, Grid, styled } from '@mui/material';

export interface ISigningPageFields {
	signingAs: boolean;
	firstName: string;
	lastName: string;
	email: string;
	isPolicyChecked: boolean;
	isRemoteContractingChecked: boolean;
	isPersonalDataChecked: boolean;
	isTruthDataChecked: boolean;
}

export const defaultValues: ISigningPageFields = {
	signingAs: false,
	firstName: '',
	lastName: '',
	email: '',
	isPolicyChecked: false,
	isRemoteContractingChecked: false,
	isPersonalDataChecked: false,
	isTruthDataChecked: false,
};

export interface IMessageProps {
	show: boolean;
	isSuccess: boolean;
	message: string;
}

export const StyledGrid = styled(Grid)(() => ({
	display: 'flex',
	'> p': { marginRight: '1rem' },
}));

export const StyledCard = styled(Card)(({ theme }) => ({
	padding: '1rem',
	maxWidth: '100%',
	margin: 'auto',
	boxShadow: '0px 0px 40px rgba(0, 0, 0, 0.3)',
	backgroundColor: '#fff',

	[theme.breakpoints.up('sm')]: {
		padding: '32px 80px 50px',
		maxWidth: '50%',
		borderRadius: 10,
	},
}));

export const StyledSection = styled('section')(({ theme }) => ({
	padding: 10,
}));

export const FlexWrapper = styled('div')(() => ({
	width: '100%',
	justifyContent: 'center',
	display: 'flex',
	paddingBottom: '1.75rem',
}));

export const StyledLink = styled('a')(() => ({
	':hover': {
		textDecoration: 'underline !important',
	},
}));

export const ContractFooter = styled(Grid)(() => ({
	paddingLeft: 12,
}));

export const ContractNoWithDownload = styled('div')(() => ({
	display: 'flex',
	width: '100%',
	justifyContent: 'space-between',
	alignItems: 'center',
	paddingRight: '30px',
}));

export const DocumentContainer = styled(Grid)(({ theme }) => ({
	border: '1px solid black',
	borderRadius: 5,
	[theme.breakpoints.down('sm')]: {
		marginTop: '1rem',
	},
	cursor: 'pointer'
}));

export const StyledDialog = styled(Dialog)(() => ({
	marginTop: 50,
}));
